import {
  Wrench, Lightning, ThermometerHot, Drop, FireSimple, Elevator, Lock, Lightbulb, Desktop, Armchair, Buildings, Door, Truck, ForkKnife, Shower, HardHat, Sun,
} from "@phosphor-icons/react";

export const CATEGORIES = [
  "HVAC", "Electrical", "Plumbing", "Fire Safety", "Lifts & Elevators", "Security Systems", "Roofing", "Doors & Windows", "Flooring",
  "Kitchen Equipment", "Bathroom Fixtures", "Lighting", "Building Structure", "IT & Network", "Furniture", "Vehicles & Plant", "Other",
];
export const CONDITIONS = ["excellent", "good", "fair", "poor", "critical"];
export const STATUSES = ["active", "inactive", "under_maintenance", "decommissioned"];
export const CRITICALITY = ["low", "medium", "high", "critical"];
export const METER_UNITS = ["hours", "kWh", "m3", "km", "miles", "cycles", "litres", "other"];
export const LOG_TYPES = [
  { value: "service", label: "Service" }, { value: "inspection", label: "Inspection" }, { value: "repair", label: "Repair" },
  { value: "meter_reading", label: "Meter reading" }, { value: "condition", label: "Condition check" }, { value: "parts", label: "Parts fitted" }, { value: "note", label: "Note" },
];

export const CATEGORY_ICONS = {
  "HVAC": ThermometerHot, "Electrical": Lightning, "Plumbing": Drop, "Fire Safety": FireSimple, "Lifts & Elevators": Elevator,
  "Security Systems": Lock, "Lighting": Lightbulb, "IT & Network": Desktop, "Furniture": Armchair, "Building Structure": Buildings,
  "Doors & Windows": Door, "Vehicles & Plant": Truck, "Kitchen Equipment": ForkKnife, "Bathroom Fixtures": Shower, "Roofing": HardHat, "Flooring": Sun,
};
export const iconFor = (category) => CATEGORY_ICONS[category] || Wrench;

export const CONDITION_COLORS = {
  excellent: "text-emerald-700 bg-emerald-50 border-emerald-200 dark:text-emerald-400 dark:bg-emerald-950/30 dark:border-emerald-800",
  good: "text-blue-700 bg-blue-50 border-blue-200 dark:text-blue-400 dark:bg-blue-950/30 dark:border-blue-800",
  fair: "text-amber-700 bg-amber-50 border-amber-200 dark:text-amber-400 dark:bg-amber-950/30 dark:border-amber-800",
  poor: "text-orange-700 bg-orange-50 border-orange-200 dark:text-orange-400 dark:bg-orange-950/30 dark:border-orange-800",
  critical: "text-red-700 bg-red-50 border-red-200 dark:text-red-400 dark:bg-red-950/30 dark:border-red-800",
};
export const STATUS_COLORS = {
  active: "text-emerald-700 bg-emerald-50 dark:text-emerald-400 dark:bg-emerald-950/30",
  inactive: "text-gray-600 bg-gray-100 dark:text-gray-400 dark:bg-gray-800",
  under_maintenance: "text-amber-700 bg-amber-50 dark:text-amber-400 dark:bg-amber-950/30",
  decommissioned: "text-red-700 bg-red-50 dark:text-red-400 dark:bg-red-950/30",
};
export const CRITICALITY_COLORS = {
  low: "text-gray-600 border-gray-300 dark:text-gray-400 dark:border-gray-700",
  medium: "text-blue-700 border-blue-300 dark:text-blue-400 dark:border-blue-800",
  high: "text-orange-700 border-orange-300 dark:text-orange-400 dark:border-orange-800",
  critical: "text-red-700 border-red-300 dark:text-red-400 dark:border-red-800",
};

export const gbp = (n) => (n === null || n === undefined || Number.isNaN(Number(n))) ? "—" : `£${Number(n).toLocaleString("en-GB", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
export const fmtD = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};
export const titleCase = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
export const todayISO = () => new Date().toISOString().slice(0, 10);

export function serviceLabel(a) {
  if (a.meter_state === "due") return { text: `Usage service due (${Number(a.meter_reading).toLocaleString()} ${a.meter_unit})`, tone: "overdue" };
  if (!a.next_service_due || a.service_state === "none") return { text: "No schedule", tone: "none" };
  if (a.service_state === "overdue") return { text: `${Math.abs(a.days_to_service)}d overdue`, tone: "overdue" };
  if (a.service_state === "due_soon") return { text: a.days_to_service === 0 ? "Due today" : `Due in ${a.days_to_service}d`, tone: "soon" };
  return { text: fmtD(a.next_service_due), tone: "ok" };
}
export const TONE_CLASSES = {
  overdue: "text-red-700 bg-red-50 border-red-200 dark:text-red-400 dark:bg-red-950/30 dark:border-red-800",
  soon: "text-amber-700 bg-amber-50 border-amber-200 dark:text-amber-400 dark:bg-amber-950/30 dark:border-amber-800",
  ok: "text-emerald-700 bg-emerald-50 border-emerald-200 dark:text-emerald-400 dark:bg-emerald-950/30 dark:border-emerald-800",
  none: "text-muted-foreground bg-muted/40 border-border",
};
export function warrantyLabel(a) {
  if (a.warranty_state === "none") return { text: "No warranty", tone: "none" };
  if (a.warranty_state === "expired") return { text: `Expired ${fmtD(a.warranty_expiry)}`, tone: "overdue" };
  if (a.warranty_state === "expiring") return { text: `Expires in ${a.warranty_days_left}d`, tone: "soon" };
  return { text: `Until ${fmtD(a.warranty_expiry)}`, tone: "ok" };
}
